import { Card, Form } from "antd";
import { useEffect, useState } from "react";

import { LineChart, Line, XAxis, YAxis, Tooltip, Legend } from "recharts";
import { API } from "../config/api";
import { POST } from "../utils/apicalls";

function AccountantDashboard() {
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState<any>([]);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(5000000);
  const fetchSalary = async () => {
    try {
      setIsLoading(true);
      let obj = {
        query: form.getFieldValue("query"),
        page: page,
        take: pageSize,
      };
      const url = API.LIST_SALARY_DETAILS;
      const response: any = await POST(url, obj);
      setData(response?.data || []);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchSalary();
  }, []);

  return (
    <div className="flex h-screen">
      <div className="flex-1 p-6 bg-gray-100">
        <h1 className="text-2xl font-bold mb-4">Financial Overview</h1>
        <div style={{ display: "flex", gap: "16px" }}>
          <Card style={{ flex: 1, padding: "16px", borderRadius: "8px", boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.1)", backgroundColor: "white" }}>
            <h3 style={{ fontSize: "1.125rem", fontWeight: "600" }}>Total Revenue</h3>
            <p style={{ fontSize: "1.25rem", fontWeight: "700" }}>
              ${data.reduce((sum: any, item: any) => sum + item.IN_Amount, 0)}
            </p>
          </Card>
          <Card style={{ flex: 1, padding: "16px", borderRadius: "8px", boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.1)", backgroundColor: "white" }}>
            <h3 style={{ fontSize: "1.125rem", fontWeight: "600" }}>Total Expenses</h3>
            <p style={{ fontSize: "1.25rem", fontWeight: "700" }}>
              ${data.reduce((sum: any, item: any) => sum + item.OUT_Amount, 0)}
            </p>
          </Card>
          <Card style={{ flex: 1, padding: "16px", borderRadius: "8px", boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.1)", backgroundColor: "white" }}>
            <h3 style={{ fontSize: "1.125rem", fontWeight: "600" }}>Net Profit</h3>
            <p style={{ fontSize: "1.25rem", fontWeight: "700" }}>
              ${data.reduce((sum: any, item: any) => sum + (item.IN_Amount - item.OUT_Amount), 0)}
            </p>
          </Card>
        </div>


        <div className="flex justify-center mt-6">
          <div className="bg-white p-4 rounded-lg shadow">
            <h2 className="text-xl font-semibold mb-4 text-center">Revenue vs Expenses</h2>
            <div className="flex justify-center mt-6">
              <LineChart width={600} height={300} data={data}>
                <XAxis dataKey="date" />
                <YAxis />
                <Tooltip />
                <Legend />
                <Line type="monotone" dataKey="IN_Amount" stroke="#4CAF50" />
                <Line type="monotone" dataKey="OUT_Amount" stroke="#F44336" />
              </LineChart>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
}

export default AccountantDashboard;
